import { z } from "zod";

export const LoginRequestSchema = z.object({
  email: z.string().email().max(255),
  password: z.string().min(6).max(200),
  keepLoggedIn: z.boolean().optional().default(false),
  totpCode: z
    .string()
    .regex(/^\d{6}$/)
    .optional(),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const LoginResponseSchema = z.object({
  accessToken: z.string(),
  user: z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string().email(),
    role: z.enum(["GESTOR", "OPERADOR"]),
    organizationId: z.string().uuid(),
    // Timezone IANA da fábrica: o cliente resolve as janelas do
    // expediente (faixas/aviso de OP) na MESMA tz que o servidor (sweep/simulação), não a do navegador.
    organizationTimezone: z.string(),
    totpEnabled: z.boolean(),
  }),
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;

export const RefreshResponseSchema = LoginResponseSchema;
export type RefreshResponse = z.infer<typeof RefreshResponseSchema>;

export const MeResponseSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  email: z.string().email(),
  role: z.enum(["GESTOR", "OPERADOR"]),
  organizationId: z.string().uuid(),
  organizationTimezone: z.string(), // Tz da fábrica p/ o expediente no cliente
  totpEnabled: z.boolean(),
});
export type MeResponse = z.infer<typeof MeResponseSchema>;

export const TotpSetupResponseSchema = z.object({
  secret: z.string(),
  otpauthUrl: z.string(),
});
export type TotpSetupResponse = z.infer<typeof TotpSetupResponseSchema>;

export const TotpVerifyRequestSchema = z.object({
  code: z.string().regex(/^\d{6}$/),
});
export type TotpVerifyRequest = z.infer<typeof TotpVerifyRequestSchema>;

export const TotpDisableRequestSchema = z.object({
  totpCode: z.string().regex(/^\d{6}$/),
  password: z.string().min(6),
});
export type TotpDisableRequest = z.infer<typeof TotpDisableRequestSchema>;
